import React from 'react';
import './styles/app.css';
import Registration from "./components/Registration";
import Preloader from "./components/Preloader";
import { useState } from 'react';
import {config} from "./config";
import axios from "axios";
import Documents from "./components/Documents";
import XMKbox from "./components/XMKbox";
import Translator from "./services/Translator";
import Header from "./components/Header";
import Home from "./components/Home";
import Information from "./components/Information";
import Settings from "./components/Settings";
import PinGate, { useAppUnlocked } from "./components/PinGate";


function App() {
    const [lang] = useState('pl');
    const [token, setToken] = useState(localStorage.getItem('token'));
    const hasPin = localStorage.getItem('pin') !== null;
    const [user, setUser] = useState(null);
    const [userRefreshed, setUserRefreshed] = useState(false);
    const [securityStatus, setSecurityStatus] = useState({type: -113, comment: null});
    const [preloader, setPreloaderState] = useState(false);
    const [screen, setScreen] = useState('home');
    const [text, setText] = useState(Translator.trans(lang, 'name'));

    const unlocked = useAppUnlocked();

    const refreshUser = () => {
        setPreloaderState(true);

        axios.get(config.api + '/user')
            .then((response) => {
                setUser(response.data);
                setPreloaderState(false);
            })
            .catch((response) => console.log(response));
    }

    const getSecurityStatus = () => {
        if (securityStatus.type !== -113) {
            return;
        }

        axios.get(config.api + '/security-status')
            .then((response) => {
                setSecurityStatus(response.data);
            })
            .catch((response) => console.log(response));
    }

    if (token != null) {
        axios.defaults.headers.common = {
            'Authorization': 'Bearer ' + token
        };

        getSecurityStatus();

        if (user === null && !userRefreshed) {
            setUserRefreshed(true);
            refreshUser();
        }
    }

    // if (config.env === 'dev') {
    //     setInterval(function() {
    //         axios.get(config.api + '/info').then((response) => console.log(response));
    //     }, 10000);
    // }

    if (!token) {
        return (
            <div className="app">
                <link href={config.api + '/public/theme.css'} rel="stylesheet" />

                <Preloader show={preloader} />

                <Header
                    lang={lang}
                    text={text}
                    securityStatus={securityStatus}
                    setScreen={setScreen}
                    setText={setText}
                />

                <Registration
                    lang={lang}
                    token={token}
                    setPreloaderState={setPreloaderState}
                    setToken={setToken}
                    refreshUser={refreshUser}
                />
            </div>
        );
    }

    if (token && hasPin && !unlocked) {
        return (
            <div className="app">
                <link href={config.api + '/public/theme.css'} rel="stylesheet" />

                <Preloader show={preloader} />

                <PinGate
                    lang={lang}
                    setPreloaderState={setPreloaderState}
                    setToken={setToken}
                    refreshUser={refreshUser}
                />
            </div>
        );
    }

    return (
        <div className="app">
            <link href={config.api + '/public/theme.css'} rel="stylesheet" />

            <div className="background" />

            <Preloader show={preloader} />

            <Header
                lang={lang}
                text={text}
                securityStatus={securityStatus}
                setScreen={setScreen}
                setText={setText}
            />

            <Home
                lang={lang}
                user={user}
                screen={screen}
                setScreen={setScreen}
                setText={setText}
            />

            <Information
                lang={lang}
                user={user}
                screen={screen}
                securityStatus={securityStatus}
            />

            <Documents
                lang={lang}
                token={token}
                user={user}
                screen={screen}
            />

            <XMKbox
                lang={lang}
                user={user}
                screen={screen}
                setPreloaderState={setPreloaderState}
            />

            <Settings
                lang={lang}
                user={user}
                screen={screen}
                setPreloaderState={setPreloaderState}
            />
        </div>
    );
}

export default App;
